import { omit } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ScrollListener from '../scroll-listener';
import scrollParent from '../../services/scroll-parent';

class InfiniteListLoader extends Component {
  shouldLoadMore = position => {
    const end = scrollParent().scrollHeight;
    return position > end && this.props.hasMore && !this.props.isLoading;
  };

  handleScroll = scroll => {
    const position = scroll.scrollTop + scroll.documentHeight + this.props.threshold;
    if (this.shouldLoadMore(position)) {
      this.props.onLoad();
    }
  };

  render = () => {
    const { element: Element, loader, hasMore, ...props } = this.props;

    const passProps = omit(props, ['scroll', 'onLoad', 'isLoading', 'threshold', 'dispatch']);

    return (
      <Element {...passProps}>
        <ScrollListener onScroll={this.handleScroll}/>
        {hasMore && loader}
      </Element>
    );
  };
}

const mapStateToProps = state => ({
  scroll: state.scroll,
});

InfiniteListLoader.propTypes = {
  element: PropTypes.string,
  scroll: PropTypes.object,
  loader: PropTypes.node,
  hasMore: PropTypes.bool,
  onLoad: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  threshold: PropTypes.number,
};

InfiniteListLoader.defaultProps = {
  element: 'div',
  hasMore: false,
  threshold: 500,
};

export default connect(mapStateToProps)(InfiniteListLoader);



// WEBPACK FOOTER //
// ./app/components/infinite-list-loader/infinite-list-loader.js